/* eslint-disable prefer-promise-reject-errors */
import shp from 'shpjs';
import fileToArrayBuffer from 'file-to-array-buffer';
import tj from 'togeojson';
import wkt from 'wkt';
import kmzToKml from './KmzToKml';

const fileTypes = ['wkt', 'kml', 'kmz', 'shp', 'zip', 'geojson', 'json'];
const parser = new DOMParser();

function toFeatureCollection(gj) {
	if (!gj || typeof gj !== 'object') {
		throw new TypeError('invalid GeoJSON.');
	}

	if (gj.type === 'FeatureCollection' && Array.isArray(gj.features)) {
		return gj;
	}

	if (gj.type === 'Feature' && gj.geometry) {
		return { type: 'FeatureCollection', features: [gj] };
	}

	if (gj.type && gj.coordinates) {
		return {
			type: 'FeatureCollection',
			features: [{ type: 'Feature', geometry: gj, properties: {} }]
		};
	}

	if (Array.isArray(gj)) {
		if (gj.length === 0) return { type: 'FeatureCollection', features: [] };
		if (gj[0].type === 'Feature') {
			return { type: 'FeatureCollection', features: gj };
		}
		if (gj[0].type && gj[0].coordinates) {
			return {
				type: 'FeatureCollection',
				features: gj.map(geometry => ({
					type: 'Feature',
					geometry,
					properties: {}
				}))
			};
		}
	}

	throw new Error('invalid GeoJSON.');
}

export default {
	async parse(extension, content, rawFile) {
		let arquivoFormatoValido = fileTypes.indexOf(extension) > -1;

		if (!arquivoFormatoValido) {
			return new Promise((resolve, reject) => {
				reject('Tipo de arquivo não permitido.');
			});
		}

		let data = null;

		switch (extension) {
			case 'wkt':
				data = {
					type: 'FeatureCollection',
					features: [
						{
							type: 'Feature',
							geometry: wkt.parse(content),
							properties: {}
						}
					]
				};
				break;

			case 'kml': {
				const xmlDoc = parser.parseFromString(content, 'text/xml');
				data = tj.kml(xmlDoc);
				break;
			}

			case 'kmz':
				await kmzToKml.parse(rawFile).then(kmlDom => {
					data = tj.kml(kmlDom);
				});
				break;

			case 'geojson':
			case 'json':
				try {
					const gj = JSON.parse(content);
					data = toFeatureCollection(gj);
				} catch (e) {
					return new Promise((resolve, reject) => {
						reject('invalid GeoJSON.');
					});
				}
				break;

			case 'zip': {
				let arrayBuffer = null;
				await fileToArrayBuffer(rawFile).then(buffer => {
					arrayBuffer = buffer;
				});
				data = await shp(arrayBuffer);
				break;
			}

			case 'shp':
				return new Promise((resolve, reject) => {
					reject('Faça o upload de um zip com os arquivos do shapefile');
				});
		}

		return new Promise((resolve) => {
			resolve(data);
		});
	}
};
